"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var API_URL = 'v1/sales-products';
exports.getSalesProductUsingGET = function (productName, params) {
    return {
        url: API_URL + "/" + productName + "?" + params.toString(),
        method: 'GET',
    };
};
exports.getObjectGroupsUsingGET = function (productName, params) {
    return {
        url: API_URL + "/" + productName + "/object-groups?" + params.toString(),
        method: 'GET',
    };
};
exports.getObjectGroupUsingGET = function (productName, objectGroupName, params) {
    return {
        url: API_URL + "/" + productName + "/object-groups/" + objectGroupName + "?" + params.toString(),
        method: 'GET',
    };
};
exports.getObjectGroupDetailsUsingGET = function (productName, objectGroupName, params) {
    return {
        url: API_URL + "/" + productName + "/object-groups/" + objectGroupName + "/details?" + params.toString(),
        method: 'GET',
    };
};
exports.getObjectGroupDetailUsingGET = function (productName, objectGroupName, detailId, params) {
    return {
        url: API_URL + "/" + productName + "/object-groups/" + objectGroupName + "/detail/" + detailId + "?" + params.toString(),
        method: 'GET',
    };
};
exports.getObjectGroupDetailInstanceUsingGET = function (productName, objectGroupName, detailId, params) {
    return {
        url: API_URL + "/" + productName + "/object-groups/" + objectGroupName + "/detail/" + detailId + "/instances/template?" + params.toString(),
        method: 'GET',
    };
};
